export default "__VITE_ASSET__CAx1KPOq__"